

$(window).ready(function(){


    // Primary update cart function, handles adding/editing/deleting property
    function updateCart(monogramInput, monogramValue, linePosition, quantity, eventType, monogramHeader, itemKey){
        // Set up the body of product data to update via AJAX
        // Based on event type (add/edit/delete)
        let dataBody = {}

        if(eventType == 'delete'){
            // Read cart once to resolve the target line by data-key.
            fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(cart => {
                let targetLineNumber = null;
                if (itemKey) {
                    const foundIndex = cart.items.findIndex(function(item){ return item.key === itemKey; });
                    if (foundIndex !== -1) {
                        targetLineNumber = foundIndex + 1;
                    }
                }
                if (!targetLineNumber) {
                    targetLineNumber = parseInt(linePosition);
                }

                return fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        line: targetLineNumber,
                        quantity: parseInt(quantity),
                        properties: {
                            "Monogram": "",
                            "Monogram Style": "",
                            "Monogram Color": ""
                        }
                    })
                });
            })
            .then(response => response.json())
            .then(function(updatedCart){
                if (updatedCart.status === 422) {
                    return Promise.reject(new Error('422 error in main product update'));
                }
                // Sync the fee using the cart we just got back — no extra /cart.js read.
                return syncMonogramFees(updatedCart);
            })
            .then(function(){
                // Single drawer rebuild now that both main change and fee sync have settled.
                document.dispatchEvent(new CustomEvent('cart:build'));

                if(monogramHeader){
                    const monogramWrapper = $(monogramInput).closest('.mg-mini-input-wrapper')
                    $(monogramWrapper).find('.mg-mini-edit').css('display', 'block')
                    $(monogramWrapper).find('.mg-mini-delete').css('display', 'block')
                    $(monogramHeader).text('Monogram:')
                }

                clearCheckoutBlock()
                if(window.location.pathname.includes('cart')){
                    window.location.reload()
                }
            })
            .catch((error) => {
                console.error('Monogram delete failed:', error);
                return error;
            });

        }else if(eventType == 'add' || eventType == 'edit'){
            // Read cart once to resolve the target line and preserve existing Style/Color.
            fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(cart => {
                let currentItem = null;
                let targetLineNumber = null;

                if (itemKey) {
                    const foundIndex = cart.items.findIndex(function(item){ return item.key === itemKey; });
                    if (foundIndex !== -1) {
                        currentItem = cart.items[foundIndex];
                        targetLineNumber = foundIndex + 1;
                    }
                }
                if (!currentItem) {
                    const fallbackIndex = parseInt(linePosition) - 1;
                    if (!isNaN(fallbackIndex) && cart.items[fallbackIndex]) {
                        currentItem = cart.items[fallbackIndex];
                        targetLineNumber = fallbackIndex + 1;
                    }
                }
                if (!currentItem) {
                    return Promise.reject(new Error('Cart item not found'));
                }

                const properties = { "Monogram": `${monogramValue}` };
                if (currentItem.properties) {
                    if (currentItem.properties['Monogram Style']) {
                        properties['Monogram Style'] = currentItem.properties['Monogram Style'];
                    }
                    if (currentItem.properties['Monogram Color']) {
                        properties['Monogram Color'] = currentItem.properties['Monogram Color'];
                    }
                }

                return fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        line: targetLineNumber,
                        quantity: parseInt(quantity),
                        properties: properties
                    })
                });
            })
            .then(response => response.json())
            .then(function(updatedCart){
                if (updatedCart.status === 422) {
                    return Promise.reject(new Error('422 error in edit/add operation'));
                }
                return syncMonogramFees(updatedCart);
            })
            .then(function(){
                document.dispatchEvent(new CustomEvent('cart:build'));

                if(monogramHeader){
                    const monogramWrapper = $(monogramInput).closest('.mg-mini-input-wrapper')
                    $(monogramWrapper).find('.mg-mini-edit').css('display', 'block')
                    $(monogramWrapper).find('.mg-mini-delete').css('display', 'block')
                    $(monogramHeader).text('Monogram:')
                }

                clearCheckoutBlock()
                if(window.location.pathname.includes('cart')){
                    window.location.reload()
                }
            })
            .catch((error) => {
                console.error('Monogram update failed:', error);
                return error;
            });
        }
    }


    // Remove any checkout-block feedback (inline alerts + button attention state).
    // Reused by updateCart cleanup and on drawer re-render.
    function clearCheckoutBlock() {
        $('.checkout-alert').remove();
        $('.checkout-block-msg').remove();
        $('.cart__checkout').removeClass('cart__checkout--blocked').removeClass('btn--loading');
        $('.mg-mini-input-wrapper').removeClass('editing adding'); // reset stale pending state
        $('#error-msg-overlay').remove(); // safety net for any legacy overlay
    }

    // Block checkout while a monogram line item is mid-edit, with visible, located feedback.
    function setupCheckoutBlock() {
        $(document).off('submit.mgCheckout').on('submit.mgCheckout', '#CartDrawerForm, #CartPageForm', function(e){
            // Only act on the checkout button (ignore "update cart"/Enter elsewhere)
            const submitter = e.originalEvent && e.originalEvent.submitter;
            if (submitter && submitter.name && submitter.name !== 'checkout') return;

            // A wrapper only truly blocks checkout if its input is enabled (mid-edit) AND
            // holds an unsaved change — i.e. a non-empty value that differs from the monogram
            // already saved on the line (captured in data-saved-monogram on Edit). A
            // saved/disabled monogram, an empty field, or simply clicking Edit without changing
            // anything must never block checkout — even if a stale editing/adding class lingers.
            const $pending = $('.mg-mini-input-wrapper.editing, .mg-mini-input-wrapper.adding')
                .filter(function(){
                    const input = $(this).find('.mg-mini-input')[0];
                    if (!input || input.disabled) return false;
                    const val = $.trim(input.value).toUpperCase();
                    if (val === '') return false; // nothing to save
                    const saved = $.trim($(input).attr('data-saved-monogram') || '').toUpperCase();
                    return val !== saved; // only a genuine unsaved change blocks
                });
            if ($pending.length === 0) return; // nothing pending -> checkout proceeds

            e.preventDefault();

            const $btn = $(this).find('button[name="checkout"].cart__checkout');
            $btn.removeClass('btn--loading'); // theme.js onSubmit may have added this

            // Inline alert next to each offending line item
            $pending.each(function(){
                const $wrapper = $(this);
                $wrapper.siblings('.checkout-alert').remove();
                const msg = $wrapper.hasClass('editing')
                    ? "Please press 'update' to continue"
                    : "Please press 'add' to continue";
                $("<span class='checkout-alert'>" + msg + "</span>").insertAfter($wrapper);
            });

            // Scroll the first offending input into view
            const firstInput = $pending.first().find('.mg-mini-input')[0];
            if (firstInput && firstInput.scrollIntoView) {
                firstInput.scrollIntoView({ block: 'nearest' });
            }

            // Visible attention state + message near the checkout button itself
            $btn.addClass('cart__checkout--blocked');
            const $wrap = $btn.closest('.cart__checkout-wrapper');
            $wrap.find('.checkout-block-msg').remove();
            $("<span class='checkout-block-msg'>Finish your monogram to continue</span>").insertBefore($btn);
        });
    }
    function setMiniCartMonogramEvents(){
        // Check if input field has valid strings
        function isValid(str) {
            return /^[a-zA-Z0-9]+$/.test(str);
        }

        // Key up event for input fields in mini cart - use delegation
        // Adds error if invalid text is entered.
        $(document).off('keypress.mgInput keyup.mgInput').on('keypress.mgInput keyup.mgInput', '.mg-mini-input', function(e){
            var key = e.key;
            if (!isValid(key)) {
                e.target.value = e.target.value.replace(/[^a-z0-9\s]/gi, '');
                e.preventDefault();
                // return false;
            }else{
                e.target.value = e.target.value.toUpperCase();
                $(this).attr('value', e.target.value)
                let wrapper = $(this).closest('.mg-mini-input-wrapper')
                // Field emptied -> no longer mid-edit; drop any pending state so checkout isn't blocked
                if($.trim(e.target.value) == ''){
                    $(wrapper).removeClass('editing adding')
                }else if($(wrapper).find('.mg-mini-add').css('display') == 'none'){
                    if(!$(wrapper).hasClass('editing')){
                        $(wrapper).addClass('editing')
                    }
                }else{
                    if(!$(wrapper).hasClass('adding')){
                        $(wrapper).addClass('adding')
                    }
                }
            }
        });

        function handleClickEvent(element, eventType){
            const prodKey = $(element).closest('.cart__item').attr("data-key")
            const quantity = $(element).closest('.cart__item-details').find('.js-qty__num').val()

            let linePosition
            $(".cart__item").each(function(index, el){
                if($(el).attr('data-key') == prodKey){
                    linePosition = index + 1
                }
            })

            const monogramInput = $(element).closest('.mg-mini-input-wrapper').find(".mg-mini-input")
            const monogramHeader = $(element).closest('.mg-mini-container').find('.mg-mini-header')
            const monogramInputValue = $(monogramInput).val()
            const monogramValue =  monogramInputValue ? monogramInputValue : ""
            const monogramInputWrapper = $(element).closest('.mg-mini-input-wrapper')

            if(eventType == 'add'){
                $(monogramInput).removeAttr('disabled');
                if($(monogramInputWrapper).hasClass('editing')){
                    $(monogramInputWrapper).removeClass('editing');
                }else if($(monogramInputWrapper).hasClass('adding')){
                    $(monogramInputWrapper).removeClass('adding');
                }
                if(monogramValue == ""){
                    // Append error message
                    const existingError = $(element).closest('.mg-mini-container').find('.monogram-error');

                    if($(existingError).length == 0){
                        $('<span class="monogram-error">Please enter a value</span>').insertAfter(monogramInputWrapper);
                    }
                } else if (!isValid(monogramValue)) {
                    // Append error message for invalid input
                    const existingError = $(element).closest('.mg-mini-container').find('.monogram-error');

                    if($(existingError).length == 0){
                        $('<span class="monogram-error">Please enter only letters and numbers</span>').insertAfter(monogramInputWrapper);
                    }
                } else {
                    if($(this).closest('.mg-mini-container').find('.monogram-error') && $(this).closest('.mg-mini-container').find('.monogram-error').length > 0){
                        $('.monogram-error').remove();
                    }
                    updateCart(monogramInput, monogramValue, linePosition, quantity, eventType, monogramHeader, prodKey);
                }
            }else if (eventType == 'edit'){
                // Remember the monogram currently saved on the line so checkout is only
                // blocked if the user actually changes it (not just for clicking Edit).
                $(monogramInput).attr('data-saved-monogram', $(monogramInput).val())
                $(monogramInput).removeAttr('disabled')
                $(monogramInputWrapper).addClass('editing')
            }else if (eventType == 'delete'){

                updateCart(monogramInput, monogramValue, linePosition, quantity, eventType, monogramHeader, prodKey)
            }

        }

        // Use event delegation for dynamic elements
        // Edit monogram click event
        $(document).off('click.mgEdit').on('click.mgEdit', '.mg-mini-edit', function(){
             handleClickEvent($(this), 'edit')
        })

        // Delete monogram click event
        $(document).off('click.mgDelete').on('click.mgDelete', '.mg-mini-delete', function(){

            handleClickEvent($(this), 'delete')
        })

        // Add monogram click event
        $(document).off('click.mgAdd').on('click.mgAdd', '.mg-mini-add', function(){
            handleClickEvent($(this), 'add')
        })

        // Update monogram click event
        $(document).off('click.mgUpdate').on('click.mgUpdate', '.mg-mini-update', function(){
            handleClickEvent($(this), 'add')
        })

    }

    // Initialize event delegation once (no need to re-run since delegation handles dynamic elements)
    setMiniCartMonogramEvents()
    setupCheckoutBlock()

    // Clear any stale checkout-block feedback when the drawer/cart re-renders
    document.addEventListener('cart:build', clearCheckoutBlock);
    document.addEventListener('cart:updated', clearCheckoutBlock);

    // Re-entrancy guard for syncMonogramFees. Declared before the function so the TDZ
    // is closed by the time any caller (event handler, setTimeout) actually runs.
    let isSyncingFees = false;

    // Reconcile the monogram-fee line quantity with the count of non-Embossed monogrammed items.
    // Returns a Promise<boolean> — resolves true when the fee line was modified, false otherwise.
    // Callers are responsible for dispatching 'cart:build' if they need a UI refresh.
    function syncMonogramFees(prefetchedCart) {
        if (!window.monogramFeeProductId) {
            return Promise.resolve(false);
        }
        if (isSyncingFees) {
            return Promise.resolve(false);
        }
        isSyncingFees = true;

        const cartPromise = prefetchedCart && prefetchedCart.items
            ? Promise.resolve(prefetchedCart)
            : fetch('/cart.js').then(response => response.json());

        return cartPromise.then(cart => {
            let feeQuantity = 0;
            let feeItem = null;
            let feeLine = null;

            cart.items.forEach((item, index) => {
                if (item.variant_id === window.monogramFeeProductId) {
                    feeItem = item;
                    feeLine = index + 1;
                } else if (
                    item.properties &&
                    item.properties['Monogram'] &&
                    item.properties['Monogram Style'] &&
                    item.properties['Monogram Style'] !== 'Embossed'
                ) {
                    feeQuantity += item.quantity;
                }
            });

            if (feeItem && feeItem.quantity !== feeQuantity) {
                return fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ line: feeLine, quantity: feeQuantity })
                }).then(() => true);
            }
            return false;
        })
        .catch(error => {
            console.error('Error syncing monogram fees:', error);
            return false;
        })
        .finally(() => {
            isSyncingFees = false;
        });
    }

    // Safety-net wrapper for paths that change the cart outside of updateCart
    // (qty steppers, form submits, theme.js cart events). Syncs the fee and
    // refreshes the drawer only when the fee was actually modified.
    function syncAndRefreshIfChanged(delay) {
        setTimeout(function() {
            syncMonogramFees().then(function(changed) {
                if (changed) {
                    document.dispatchEvent(new CustomEvent('cart:build'));
                }
            });
        }, delay || 0);
    }

    // cart:build is dispatched on every drawer rebuild. We still sync here as a
    // safety net but skip if a sync is already running so we don't fight ourselves.
    document.addEventListener('cart:build', function() {
        if (isSyncingFees) return;
        syncAndRefreshIfChanged(300);
    });

    // Quantity stepper and qty-input changes bypass updateCart entirely.
    $(document).on('change', '.js-qty__num', function() {
        syncAndRefreshIfChanged(500);
    });

    $(document).on('click', '.js-qty__adjust', function() {
        syncAndRefreshIfChanged(500);
    });

    document.addEventListener('cart:quantity', function() {
        syncAndRefreshIfChanged(500);
    });

    document.addEventListener('cart:updated', function() {
        syncAndRefreshIfChanged(500);
    });

    $(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url && (settings.url.includes('cart/change.js') || settings.url.includes('cart/update.js'))) {
            syncAndRefreshIfChanged(300);
        }
    });

    $(document).on('submit', 'form[action*="cart"]', function() {
        syncAndRefreshIfChanged(500);
    });

})
